// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader/dist/cjs.js?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-052e3024&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Notification/Notification.vue
// module id = 438
// module chunks = 0